import React from "react";
import { Link } from "react-router-dom";
import { InnovriddhiMark } from "./InnovriddhiMark";
import { ExternalLink, Mail, MapPin } from "lucide-react";

export const Footer: React.FC = () => {
  return (
    <footer className="bg-charcoal text-cream-200 border-t border-charcoal-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-12">
          {/* Brand Info */}
          <div className="lg:col-span-2 space-y-4">
            <div className="flex items-center gap-3 text-cream-100">
              <InnovriddhiMark
                size={32}
                form="interlaced"
                className="text-cream"
              />
              <span className="font-brand text-2xl font-bold tracking-tight">
                Innovriddhi
              </span>
            </div>
            <p className="text-sm text-cream-400 max-w-sm leading-relaxed">
              Operational clarity for businesses that run in the field.
              High-reliability software infrastructure for Indian distribution
              networks and mobile workforces.
            </p>
            <div className="pt-2 space-y-2 text-xs text-cream-400">
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-cream-500 shrink-0" />
                <span>Bengaluru, Karnataka, India</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-cream-500 shrink-0" />
                <a
                  href="mailto:info@innovriddhi.com"
                  className="hover:text-cream transition-colors underline-offset-4 hover:underline"
                >
                  info@innovriddhi.com
                </a>
              </div>
            </div>
          </div>

          {/* Column 2: Products */}
          <div className="space-y-3">
            <h4 className="font-mono text-xs uppercase tracking-widest text-cream-500">
              Products
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a
                  href="https://ivmanage.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 hover:text-white transition-colors group"
                >
                  <span>ivManage</span>
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-emerald-950 text-emerald-300 font-mono border border-emerald-800/60">
                    LIVE
                  </span>
                  <ExternalLink className="w-3 h-3 text-cream-500 group-hover:text-white" />
                </a>
              </li>
              <li>
                <a
                  href="/#products"
                  className="inline-flex items-center gap-1.5 hover:text-white transition-colors"
                >
                  <span>Product 02 (Name TBA)</span>
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-amber-950/80 text-amber-300 font-mono border border-amber-800/60">
                    SOON
                  </span>
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Company */}
          <div className="space-y-3">
            <h4 className="font-mono text-xs uppercase tracking-widest text-cream-500">
              Company
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a
                  href="/#principles"
                  className="hover:text-white transition-colors"
                >
                  Operating Principles
                </a>
              </li>
              <li>
                <a
                  href="/#about"
                  className="hover:text-white transition-colors"
                >
                  About Innovriddhi
                </a>
              </li>
              <li>
                <a
                  href="/#contact"
                  className="hover:text-white transition-colors"
                >
                  Enterprise Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Legal & Trust */}
          <div className="space-y-3">
            <h4 className="font-mono text-xs uppercase tracking-widest text-cream-500">
              Legal & Privacy
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/legal"
                  className="hover:text-white transition-colors"
                >
                  Legal Centre
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-of-use"
                  className="hover:text-white transition-colors"
                >
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link
                  to="/acceptable-use-policy"
                  className="hover:text-white transition-colors"
                >
                  Acceptable Use Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-charcoal-800 flex flex-col sm:flex-row items-center justify-between text-xs text-cream-500 gap-4">
          <p>
            © {new Date().getFullYear()} Innovriddhi Technologies Private
            Limited. All rights reserved.
          </p>
          <p className="font-mono">Built for Indian field operations.</p>
        </div>
      </div>
    </footer>
  );
};
